import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "../styles/successstories.css";

const testimonials = [
  {
    name: "Sarah Johnson",
    title: "Software Engineer, Tech Solutions Inc.",
    image: "https://i.pravatar.cc/100?img=1",
    quote:
      "Poly Quizz helped me pass my AWS certification on the first try. The practice tests were incredibly similar to the actual exam, and the analytics helped me focus on my weak areas.",
    tag: "AWS Solutions Architect",
  },
  {
    name: "Michael Chen",
    title: "Medical Student, University of California",
    image: "https://i.pravatar.cc/100?img=2",
    quote:
      "The USMLE simulations were spot-on. I particularly appreciated the explanations for each question, which helped solidify my understanding of complex medical concepts.",
    tag: "USMLE Step 1",
  },
  {
    name: "Priya Desai",
    title: "Data Analyst, FinTech Corp.",
    image: "https://i.pravatar.cc/100?img=3",
    quote:
      "With Poly Quizz, I gained the confidence I needed for the Social Work ASWB certification. The content was current and comprehensive.",
    tag: "Social Work ASWB",
  },
  {
    name: "Ahmed Khan",
    title: "Cloud Engineer, InnovateX",
    image: "https://i.pravatar.cc/100?img=4",
    quote:
      "Thanks to PolyQuizz, I passed my Cloud Practitioner certification on the first attempt. The dashboard and test feedback were incredibly helpful.",
    tag: "AWS Cloud Practitionerr",
  },
  {
    name: "Emily Davis",
    title: "IT Support, TechNet",
    image: "https://i.pravatar.cc/100?img=5",
    quote:
      "Poly Quizz’s simulations were very realistic. The explanations helped me understand each concept clearly before the real exam.",
    tag: "CompTIA Cloud+",
  },
  {
    name: "Ravi Sharma",
    title: "Network Engineer, Infosol",
    image: "https://i.pravatar.cc/100?img=6",
    quote:
      "I loved the ease of use and how detailed each test was. It made preparation much smoother for my CCNA certification.",
    tag: "CCNA",
  },
  {
    name: "Lena Müller",
    title: "Healthcare IT, MedTech GmbH",
    image: "https://i.pravatar.cc/100?img=7",
    quote:
      "The intuitive UI and in-depth feedback made it easy to prepare efficiently for my exam without wasting time.",
    tag: "PTCE",
  },
  {
    name: "Carlos Ruiz",
    title: "Software Tester, QASolutions",
    image: "https://i.pravatar.cc/100?img=8",
    quote:
      "Excellent resource for CompTIA Security+ prep. Realistic test scenarios and targeted feedback made all the difference.",
    tag: "CompTIA Security+",
  },
];

const SuccessStories = () => {
  return (
    <div className="success-stories">
      <h2>Success Stories</h2>
      <p>
        Hear from students who have achieved their certification goals with
        Poly Quizz. Join thousands of successful test-takers who prepared with our
        platform.
      </p>

      <div className="swiper-container-wrapper">
      <Swiper
  modules={[Navigation, Pagination]}
  navigation={{
    nextEl: ".swiper-button-next-custom",
    prevEl: ".swiper-button-prev-custom",
  }}
  pagination={{
    el: ".swiper-pagination",
    clickable: true,
  }}
  slidesPerView={1}
  breakpoints={{
    768: { slidesPerView: 1 },
    1024: { slidesPerView: 1 },
  }}
>
          {[0, 2, 4, 6].map((i) => (
            <SwiperSlide key={i}>
              <div className="card-group">
                <TestimonialCard {...testimonials[i]} />
                <TestimonialCard {...testimonials[i + 1]} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-controls">
        <div>
        <div className="swiper-button-prev-custom">
  <svg width="16" height="16" fill="currentColor"><path d="M11 14L5 8l6-6" stroke="currentColor" strokeWidth="2" fill="none"/></svg>
</div>
<div className="swiper-button-next-custom">
  <svg width="16" height="16" fill="currentColor"><path d="M5 14l6-6-6-6" stroke="currentColor" strokeWidth="2" fill="none"/></svg>
</div>
        </div>
        <div className="swiper-pagination"></div>
      </div>
    </div>
    </div>
  );
};

const TestimonialCard = ({ name, title, image, quote, tag }) => (
  <div className="testimonial-card">
    <div className="profile">
      <img src={image} alt={name} />
      <div>
        <h4>{name}</h4>
        <p>{title}</p>
      </div>
    </div>
    <div className="stars">⭐⭐⭐⭐⭐</div>
    <blockquote>{`"${quote}"`}</blockquote>
    <span className="tag">{tag}</span>
  </div>
);

export default SuccessStories;
